import { formatWebRtcConnectionMetrics, type WebRtcConnectionMetrics } from './rtc-path';

export type ConnectionTrendLevel = 'good' | 'normal' | 'warn' | 'unknown';

export const CONNECTION_TREND_LIMIT = 30;

export interface ConnectionTrendSummary {
  label: '稳定' | '基本稳定' | '需要留意' | '收集中';
  observed: number;
  good: number;
  normal: number;
  warn: number;
}

export function connectionTrendLevel(metrics: WebRtcConnectionMetrics): ConnectionTrendLevel {
  switch (formatWebRtcConnectionMetrics(metrics)) {
    case '连接顺畅': return 'good';
    case '连接一般': return 'normal';
    case '连接较慢': return 'warn';
    default: return 'unknown';
  }
}

export function appendConnectionTrend(
  history: readonly ConnectionTrendLevel[],
  metrics: WebRtcConnectionMetrics,
): ConnectionTrendLevel[] {
  const next = [...history, connectionTrendLevel(metrics)];
  return next.length > CONNECTION_TREND_LIMIT ? next.slice(-CONNECTION_TREND_LIMIT) : next;
}

export function summarizeConnectionTrend(
  history: readonly ConnectionTrendLevel[],
): ConnectionTrendSummary {
  const good = history.filter((level) => level === 'good').length;
  const normal = history.filter((level) => level === 'normal').length;
  const warn = history.filter((level) => level === 'warn').length;
  const observed = good + normal + warn;
  if (observed === 0) return { label: '收集中', observed, good, normal, warn };
  const warnRatio = warn / observed;
  const goodRatio = good / observed;
  return {
    label: warnRatio >= 0.35 ? '需要留意' : goodRatio >= 0.7 && warn === 0 ? '稳定' : '基本稳定',
    observed,
    good,
    normal,
    warn,
  };
}
